import TrackingHttp from "../../trackingHttp";

class OwnerServices {
  static async createOwner(data) {
    return TrackingHttp.post('/owners', data);
  }

  static async getAllOwners() {
    return TrackingHttp.get('/owners');
  }

  static async getOwnerById(id) {
    return TrackingHttp.get(`/owners/${id}`);
  }

  static async updateOwnerById(id, data) {
    return TrackingHttp.update(`/owners/${id}`, data);
  }

  static async deleteOwnerById(id) {
    return TrackingHttp.delete(`/owners/${id}`);
  }
}

export default OwnerServices;
